module.exports = __webpack_public_path__ + "img/965.d0e59640.png";